import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../../components/inputs/SearchInput';
import styles from './OperatorHeader.styles';
import PersonIcon from '@mui/icons-material/Person';

export default function OperatorHeader({
  title = 'Operators',
  onSearch,
  searchQuery,
  setSearchQuery,
}) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <PersonIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>{title}</Typography>
      </Box>

      <SearchInput
        value={searchQuery}
        onChange={setSearchQuery}
        onSearch={onSearch}
      />
    </Box>
  );
}
